import { helpers } from '../helpers.js';

var event = {
	init: function () {
		const self = this;

		self.checkForEventStatus();

		self.updateDateCalc();
		self.openMoreDates();
		self.showCurrentDateInDetail();
		self.generateDatesInEventItem();
		self.openEventDatesModal();
		self.showHideMorePreview();
		self.openPlacesInEvent();
	},

	openPlacesInEvent: function () {
		jQuery( '.js-openPlacesInEvent' ).on( 'click', function( event ){
			event.preventDefault();

			jQuery( '#places-in-event' ).removeClass( 'd-none' );
			jQuery( '#places-in-event .initmap__click' ).trigger( 'click' );
		});

		jQuery( '.js-openPlacesInEventClose' ).on( 'click', function( event ){
			event.preventDefault();

			jQuery( '#places-in-event' ).addClass( 'd-none' );
		});
	},

	showHideMorePreview: function () {
		jQuery( '.js-showMorePreview' ).on( 'click', function( event ) {
			event.preventDefault();

			jQuery( this ).addClass( 'd-none' );
			jQuery( this ).parent().find( '.js-showLessPreview' ).removeClass( 'd-none' );
			
			const getDivID = jQuery( this ).attr( 'href' );
			jQuery( getDivID ).removeClass( 'd-none' );
		});
		
		jQuery( '.js-showLessPreview' ).on( 'click', function( event ) {
			event.preventDefault();

			jQuery( this ).addClass( 'd-none' );
			jQuery( this ).parent().find( '.js-showMorePreview' ).removeClass( 'd-none' );
			
			const getDivID = jQuery( this ).attr( 'href' );
			jQuery( getDivID ).addClass( 'd-none' );
		});
	},

	openEventDatesModal: function(){
		if( ! jQuery( '.js-openEventDates').length ) {
			return false;
		}

		jQuery( '.js-openEventDates').on( 'click', function( event ){
			event.preventDefault();

			jQuery( '.event-dates-posts__contents + p > a' ).attr( 'href', jQuery( this ).attr( 'href' ) );
			jQuery( '.event-dates-posts__contents h3' ).text( jQuery( this ).attr( 'title' ) );
			jQuery( '.event-dates-posts__contents h3 + div' ).html( jQuery( this ).parent().find( 'table' ).clone() );

			jQuery( '.event-dates-posts__contents h3 + div' ).addClass( 'possible-text-content' );
			jQuery( '.event-dates-posts__contents h3 + div > table.d-none' ).removeClass( 'd-none' );

			jQuery.fancybox.open({
				src: '.event-dates-posts',
				type : 'inline',
				touch: false,
			});
		});
	},

	generateDatesInEventItem: function() {
		const self = this;

		if( ! jQuery( '.js-openEventDates').length ) {
			return false;
		}

		// Current date in a comparable format
		var currentDate = new Date();

		// Iterate over each element with the class .js-openEventDates
		jQuery('.js-openEventDates').each(function() {
			var $this = jQuery(this);
			
			// Get the data-datesjson attribute and parse it
			var datesJson 	= $this.attr( 'data-datesjson' );
			var datesArray 	= JSON.parse( datesJson );
	
			// Filter out the past dates
			var sortedDates = {};
			var index = 0;
			datesArray.map(function(dateRange) {
				var endDateStr 	= dateRange[1]; // Get the end date from each range
				var endDate 	= new Date(endDateStr.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")); // Convert to Date object

				// Keep only dates in the future or today
				if (endDate >= currentDate) {
					var startDate = new Date(dateRange[0].replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")); // Convert to Date object
					sortedDates[startDate.getTime() * 1000 + index] = dateRange;
					index++;
				}

				return dateRange;
			});

			// Sort dates
			sortedDates = Object.keys(sortedDates).sort().reduce(
				(obj, key) => {
					obj[key] = sortedDates[key];
					return obj;
				},
				{}
			);

			var validDates = Object.values(sortedDates);

			// Count valid dates
			var validDatesCount = validDates.length;

			// Set first date to tile
			var startDate 	= validDates[0][0];
			var endDate 	= validDates[0][1];

			startDate = startDate.replace(/ (\d{1,2}:\d{2})$/, ', $1');
			endDate = endDate.replace(/ (\d{1,2}:\d{2})$/, ', $1');

			if( moment(startDate, 'DD-MM-YYYY, HH:mm').format('DD-MM-YYYY') == moment(endDate, 'DD-MM-YYYY, HH:mm').format('DD-MM-YYYY') ) {
				endDate = moment(endDate, 'DD-MM-YYYY, HH:mm').format('HH:mm');
			} else {
				endDate = moment(endDate, 'DD-MM-YYYY, HH:mm').format('D. M. Y, HH:mm');
			}

			startDate = moment(startDate, 'DD-MM-YYYY, HH:mm').format('D. M. Y, HH:mm');

			startDate = startDate.replaceAll( '-', '. ' ).replaceAll( ', 00:00', '' ).replaceAll( ', 23:59', '' );

			endDate = endDate.replaceAll( '-', '. ' ).replaceAll( ', 00:00', '' );
			endDate = startDate == endDate || endDate.includes( '23:59' ) ? '' : " — " + endDate;
			
			$this.closest(".tile-switching").find( "h2 + p ").text( startDate + endDate );
			$this.closest(".date-display-sidebar").find("p ").text(startDate + endDate);
			$this.closest(".date-display-page").find("h2 + p ").text(startDate + endDate);
			// If there are valid dates, build a table
			if (validDatesCount < 2 ) {
				return true;
			}

			var datesText 	= validDatesCount >= 5 ? pctVars.l18n.booking.terms[1] : pctVars.l18n.booking.terms[0];
			var table 		= jQuery('<table>').addClass('d-none');
			var tbody 		= jQuery('<tbody>');

			// Add each valid date to the table
			validDates.forEach(function(dateRange) {
				var startDate 	= dateRange[0];
				var endDate 	= dateRange[1];

				startDate = startDate.replaceAll( '-', '. ' );
				startDate = startDate.replaceAll( '00:00', '' );
				startDate = startDate.replaceAll( '23:59', '' );

				if( startDate == endDate || endDate.includes( '23:59' ) ) {
					endDate = '';
				} else {
					endDate = endDate.replaceAll( '-', '. ' );
					endDate = endDate.replaceAll( '00:00', '' );
				}

				tbody.append(
					jQuery('<tr>').append('<td>' + startDate + '</td>').append('<td>' + endDate + '</td>')
				);				
			});

			// Append the table parts together
			table.append(tbody);

			// Insert the table before the element
			$this.before(table);

			// Update the text in the element with the count
			$this.text( `${validDatesCount} ${datesText}` ).removeClass('d-none');
		});
	},

	checkForEventStatus: function() {
		const self = this;

		if( ! jQuery( 'span.event-status-data' ) ) {
			return false;
		}

		const dateEnd = jQuery( 'span.event-status-data' ).attr( 'data-end' );
		const givenDate = new Date( dateEnd ); // Convert the given date string to a Date object
		const currentDate = new Date(); // Get the current date and time

		if( givenDate < currentDate ) {
			helpers.showMessage( 
				`<p><span data-sikmon="bookDate"></span> ${pctVars.l18n.event.no_terms}</p>`, '.article-head .container', 'date-alert date-alert--bolder mt-3', false, 
			);
		}
	},

	openMoreDates: function() {
		const self = this;

		if( ! jQuery( '.event_dates' ) ) {
			return false;
		}

		jQuery( '[data-eventmodal]' ).on( 'click', function( event ){
			event.preventDefault();

			const jsonData 	= JSON.parse( jQuery( this ).attr( 'data-eventmodal' ) );
			
			jQuery( '.event-dates-posts__contents + p > a' ).attr( 'href', jsonData.link );
			jQuery( '.event-dates-posts__contents h3' ).text( jsonData.title );
			jQuery( '.event-dates-posts__contents h3 + div' ).html( jQuery( `#${jsonData.table_id}` ).html() );

			jQuery.fancybox.open({
				src: '.event-dates-posts',
				type : 'inline',
				touch: false,
			});
		});
	},
	
	updateDateCalc: function() {
		const self = this;

		if( ! jQuery( '.event_dates' ) ) {
			return false;
		}

		jQuery( '[data-eventmodal]' ).each(function(){
			const parent 			= jQuery( this ).parent();
			const jsonData 			= JSON.parse( jQuery( this ).attr( 'data-eventmodal' ) );
			const count 			= jQuery( `#${jsonData.table_id} .single-row-event:not( [data-limitedstart] )` ).length;
			const stringTypes 		= JSON.parse( jQuery( this ).attr( 'data-strings' ) ); 

			let mostRecentDate 		= '';
			let stringCount 		= '';
			
			if( count == 0 ) {
				return;
			}

			if( count == 1 ) {
				jQuery( this ).remove();
				parent.removeClass( 'd-none' );
			} else {
				if( count >= 2 && count <= 4 ) {
					stringCount = stringTypes[1];
				} else {
					stringCount = stringTypes[0];
				}

				stringCount = stringCount.replace( '%d', count );
				jQuery( this ).text( stringCount );
			}

			jQuery( `#${jsonData.table_id} .single-row-event:not( [data-limitedstart] )` ).each(function(){
				mostRecentDate = jQuery( this ).find( 'th' ).text();
				return false;
			})

			parent.find( 'span' ).text( mostRecentDate );
			parent.removeClass( 'd-none' );
		});
	},
	
	showCurrentDateInDetail: function() {
		const self = this;

		var $element = jQuery('[data-date_list]');

		if ($element.length == 0) {
			return false;
		}

		var hash = window.location.hash;
		if ( hash.indexOf( "#d=" ) === 0 ) {
			var value = hash.substring(3); // Remove '#d=' from the hash
			value = decodeURIComponent(value); // Decode any URL-encoded characters
			$element.text( value );
			return true;
		}

		var today = new Date();
        today.setHours(0, 0, 0, 0); // Ignore time, focus only on the date

        // Parse the data-date_list attribute
        var dateList = JSON.parse($element.attr('data-date_list'));

        // Iterate through the date list and find the first valid date range
        for (var i = 0; i < dateList.length; i++) {
            var startDateStr = dateList[i][0].start;
            var endDateStr = dateList[i][0].end;
            var startDate = self.parseDate(startDateStr);
            var endDate = self.parseDate(endDateStr);

            // Check if the interval is valid: end date is today or in the future
            if (endDate >= today) {
                // Insert the format into the element's text
                $element.text(dateList[i][0].format);
                break; // Stop after finding the first matching date range
            }
        }
	},

	// Function to parse date strings in "dd/mm/yyyy hh:mm" format
	parseDate: function (dateStr) {
		const self = this;

		let parts = dateStr.split(" ");
		let dateParts = parts[0].split("/");
		return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
	}
};

export { event };